import { Navigate, Outlet } from 'react-router-dom';
import { useGetMe } from '@hooks/useGetMe.ts';
import { TRole } from '@src/types';

export const AdminAuthLayout = () => {
  const { me } = useGetMe();

  if (me?.id) {
    if (me?.role === TRole.Admin) {
      return <Navigate replace={true} to={'/admin'} />;
    }

    return <Navigate replace={true} to={'/'} />;
  }

  return (
    <div className={'w-full'}>
      <div className="fixed top-41 lg:top-61 xl:top-71 -z-10 -pb-20">
        <img
          alt="leeloo-admin"
          className="w-full object-cover"
          src="/assets/bg_admin.png"
        />
      </div>
      <div className="max-w-7xl m-auto p-6 md:p-8 xl:p-12 relative z-1">
        <div className="flex justify-between lg:items-start items-center lg:gap-x-12 xl:gap-x-20 flex-col lg:flex-row">
          <div className="mb-8 lg:mb-0 lg:py-18 xl:py-30">
            <img
              alt="leeloo-logo"
              className="mb-4 lg:mb-6"
              src="/assets/logo.svg"
            />
            <h3 className="text-3xl lg:text-4xl font-bold">Admin Module</h3>
          </div>
          <div className={'w-full lg:w-fit pt-20 lg:pt-31 xl:pt-45 '}>
            <Outlet />
          </div>
        </div>
      </div>
    </div>
  );
};
